import React from "react"
import { IconMenu, IconButton, MenuItem, Toggle } from "material-ui"
import AppStateStore from "../../../stores/AppStateStore"
import strings from "../../../localization/strings"
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert"
import { ITableColumnSelect } from "../../../models"

interface IProps {
  columns: ITableColumnSelect[]
  handleChange(columns: ITableColumnSelect[]): void
}

const ColumnSelector: React.SFC<IProps> = (props: IProps) => {
  const activeColumnsLength = props.columns.filter(x => x.value === true).length
  return (
    <IconMenu
      clickCloseDelay={0}
      iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
      anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
    >
      {props.columns.filter(i => i.show).map((item, index) =>
        <MenuItem key={index} style={{ minHeight: 35 }}>
          <Toggle
            name={item.label}
            toggled={item.value}
            label={item.label}
            onToggle={(event, value) =>
              (!value && activeColumnsLength === 1) ?
                AppStateStore.setProgressSnackbarContent(strings.Column_Selector_One_Column_Error_Message_Text) :
                props.handleChange(props.columns.map(col => {
                  if (col.label === item.label) {
                    col.value = value
                  }
                  return col
                }))
            }
            labelStyle={{ fontSize: 14 }}
          />
        </MenuItem>
      )}
    </IconMenu>
  )
}

export default ColumnSelector